/* == from section custom_liquid_VYQkHA == */
;
(function(){
  /* ── Only run on the Bliss PDP ── */
  if(window.location.pathname.indexOf('/products/bliss-leather-heated-massage-chair') === -1) return;

  var btn = document.getElementById('bp-atc-btn');
  if(!btn) return;

  /* ── Find the REAL theme ATC button (same proven chain as #bliss-sticky-btn) ── */
  function getMainAtcBtn(){
    return document.getElementById('elite-atc-btn')
      || document.querySelector('form[action="/cart/add"] button[type="submit"]')
      || document.querySelector('form[action="/cart/add"] [name="add"]')
      || document.querySelector('.product-form__submit')
      || document.querySelector('button[name="add"]');
  }

  /* ── Hero ATC click → proxy to the real theme add button (adds + opens drawer) ── */
  function blissHeroAdd(){
    var real = getMainAtcBtn();
    if(real){ real.click(); return; }
    /* Fallback only if the real ATC button isn't on the page yet */
    window.scrollTo({top:0,behavior:'smooth'});
  }

  btn.addEventListener('click', blissHeroAdd);
  btn.addEventListener('keydown', function(e){
    if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); blissHeroAdd(); }
  });
})();

/* == from section custom_liquid_VYQkHA == */
;
(function(){
  /* bp-testi-arrows-fix: deterministic testimonial nav; see build/fix_carousel_arrows.py */
  function init(){
    var arrows = document.querySelector('.bp-arrows');
    if(!arrows || arrows.dataset.bpNavBound) return;
    var radios = Array.prototype.slice.call(document.querySelectorAll('input[name="bp-testi"]'));
    if(radios.length < 2) return;   /* nothing to navigate */
    arrows.dataset.bpNavBound = '1';
    function currentIndex(){            /* re-measure live on every click */
      for(var i=0;i<radios.length;i++){ if(radios[i].checked) return i; }
      return 0;
    }
    function go(delta){
      var n = radios.length;
      var target = ((currentIndex() + delta) % n + n) % n;   /* clamp + wrap into [0,n-1] */
      var r = radios[target];
      if(r && !r.checked){
        r.checked = true;   /* CSS :checked updates slide + counter + dots automatically */
        try{ r.dispatchEvent(new Event('change', {bubbles:true})); }catch(e){}
      }
    }
    arrows.addEventListener('click', function(e){   /* one delegated handler for all 8 labels */
      var lbl = e.target && e.target.closest ? e.target.closest('label.bp-arrow') : null;
      if(!lbl || !arrows.contains(lbl)) return;
      e.preventDefault();   /* take over from the flaky native label->radio toggle */
      go(lbl.classList.contains('bp-arrow-l') ? -1 : 1);
    }, false);
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  window.addEventListener('load', init);   /* re-attempt after app embeds settle */
})();

/* == from section custom_liquid_C6VRiA == */
;
        function blissEcGetMainAtcBtn(){
          return document.getElementById('elite-atc-btn')
            || document.querySelector('form[action="/cart/add"] button[type="submit"]')
            || document.querySelector('form[action="/cart/add"] [name="add"]')
            || document.querySelector('.product-form__submit')
            || document.querySelector('button[name="add"]');
        }
        function blissEcAddToCart(){
          var b=blissEcGetMainAtcBtn();
          if(b && !b.disabled){ b.click(); return; } /* clicks button[name="add"].product-form__submit */
          if(b){ var y=b.getBoundingClientRect().top+window.pageYOffset-80; window.scrollTo({top:Math.max(0,y),behavior:'smooth'}); return; }
          /* graceful fallback: direct AJAX add */
          fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:45341989404994,quantity:1})}).then(function(){window.location.href='/cart';});
        }
      
/* == from section custom_liquid_T63YBF == */
;
(function(){
  /* ── Only run on the Bliss PDP ── */
  if(window.location.pathname.indexOf('/products/bliss-leather-heated-massage-chair') === -1) return;
  var bar = document.getElementById('bliss-sticky-atc');
  if(!bar) return;
  bar.style.display = '';

  /* ── Money formatter ── */
  function fmtMoney(cents){
    var d=(cents/100).toFixed(2),p=d.split('.');
    p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');
    return (p[1]==='00')?'$'+p[0]+'.00':'$'+p[0]+'.'+p[1];
  }

  /* ── Find the main ATC button (proven universal proxy) ── */
  function getMainAtcBtn(){
    return document.getElementById('elite-atc-btn')
      || document.querySelector('form[action="/cart/add"] button[type="submit"]')
      || document.querySelector('form[action="/cart/add"] [name="add"]')
      || document.querySelector('.product-form__submit')
      || document.querySelector('button[name="add"]');
  }
  function getBuyBox(){
    return document.querySelector('[id*="__main"] .product__info-container')
      || document.querySelector('.product__info-wrapper')
      || document.querySelector('.product-form')
      || getMainAtcBtn();
  }

  /* ── Live price (defaults to $1,499.99 in markup) ── */
  var priceEl=document.getElementById('bl-sticky-price');
  fetch('/products/bliss-leather-heated-massage-chair.js')
    .then(function(r){return r.json();})
    .then(function(pr){ var v=pr.variants&&pr.variants[0]; if(v&&priceEl) priceEl.textContent=fmtMoney(v.price); })
    .catch(function(){});

  /* ── Show/hide sticky bar based on main ATC visibility ── */
  function checkVisibility(){
    var btn=getMainAtcBtn();
    if(!btn){ bar.classList.remove('visible'); return; }
    var r=btn.getBoundingClientRect();
    if(r.bottom<0){ bar.classList.add('visible'); } else { bar.classList.remove('visible'); }
  }
  var ticking=false;
  window.addEventListener('scroll',function(){ if(!ticking){ requestAnimationFrame(function(){checkVisibility();ticking=false;}); ticking=true; } },{passive:true});
  window.addEventListener('resize',checkVisibility);

  /* ── Picker helpers for graceful fallback ── */
  function pickerRoot(){
    return document.querySelector('variant-radios[data-section*="__main"]')
      || document.querySelector('variant-selects[data-section*="__main"]')
      || document.querySelector('variant-radios')
      || document.querySelector('variant-selects')
      || document.querySelector('.product-form__input');
  }
  function pulsePicker(){ var root=pickerRoot(); if(!root) return; root.classList.remove('bl-picker-pulse'); void root.offsetWidth; root.classList.add('bl-picker-pulse'); setTimeout(function(){ root.classList.remove('bl-picker-pulse'); },2100); }
  function scrollToPicker(){ var box=getBuyBox()||pickerRoot()||document.querySelector('.product'); if(box){ var y=box.getBoundingClientRect().top+window.pageYOffset-80; window.scrollTo({top:Math.max(0,y),behavior:'smooth'}); } else { window.scrollTo({top:0,behavior:'smooth'}); } }

  /* ── Sticky button click → proxy to main ATC (proven add) ── */
  var stickyBtn=document.getElementById('bl-sticky-btn');
  var defaultBtnHTML=stickyBtn?stickyBtn.innerHTML:'Add to Cart';
  if(stickyBtn){
    stickyBtn.addEventListener('click',function(){
      var mainBtn=getMainAtcBtn();
      if(mainBtn && !mainBtn.disabled){
        mainBtn.click(); /* clicks button[name="add"].product-form__submit -> Dawn AJAX add + cart drawer + tracking */
        stickyBtn.innerHTML='Added ✓';
        stickyBtn.classList.add('is-added');
        stickyBtn.disabled=true;
        setTimeout(function(){ stickyBtn.innerHTML=defaultBtnHTML; stickyBtn.classList.remove('is-added'); stickyBtn.disabled=false; },2200);
        return;
      }
      if(mainBtn){ scrollToPicker(); pulsePicker(); return; }
      /* Hard fallback: direct cart add via AJAX */
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:45341989404994,quantity:1})}).then(function(){ window.location.href='/cart'; });
    });
  }
})();

/* == from section ff_pdp_scale == */
;
(function(){
  function init(){
    var slider=document.querySelector('.thumbnail-slider'), list=document.querySelector('.thumbnail-list');
    if(!slider||!list||slider.querySelector('.ff-more')) return;
    function img(){ return document.querySelector('.product__media-item.is-active .product__media')||document.querySelector('.product__media'); }
    var badge=document.createElement('div'); badge.className='ff-more'; badge.setAttribute('hidden','');
    badge.appendChild(document.createElement('span'));
    slider.appendChild(badge);
    var off=0, cap=0;
    function desktop(){ return window.matchMedia && matchMedia('(min-width:990px)').matches; }
    function items(){ return Array.prototype.filter.call(list.querySelectorAll('.thumbnail-list__item'), function(t){ return t.getBoundingClientRect().height>0; }); }
    function maxoff(){ return Math.max(0, list.scrollHeight - cap); }
    function sync(){
      if(!desktop()||cap<=0){ badge.setAttribute('hidden',''); return; }
      var winB=off+cap, h=0;
      items().forEach(function(t){ if(t.offsetTop + t.offsetHeight > winB + 2) h++; });
      if(h>0){ badge.firstChild.textContent='+'+h; badge.removeAttribute('hidden'); } else badge.setAttribute('hidden','');
    }
    function apply(){ list.style.setProperty('--ff-off', off+'px'); sync(); }
    function setCap(){
      var m=img(); if(!m) return;
      if(!desktop()){ slider.style.removeProperty('--ff-cap'); off=0; list.style.setProperty('--ff-off','0px'); badge.setAttribute('hidden',''); return; }
      cap=Math.round(m.getBoundingClientRect().height); slider.style.setProperty('--ff-cap', cap+'px');
      off=Math.min(off, maxoff()); apply();
    }
    badge.addEventListener('click', function(){ var mo=maxoff(); off=(off>=mo-1)?0:Math.min(mo, off+Math.round(cap*0.85)); apply(); });
    slider.addEventListener('wheel', function(e){ var mo=maxoff(); if(!desktop()||mo<=0) return; var nx=Math.min(mo, Math.max(0, off+e.deltaY)); if(nx!==off){ e.preventDefault(); off=nx; apply(); } }, {passive:false});
    var mi=img()&&img().querySelector('img'); if(mi){ if(mi.complete) setCap(); mi.addEventListener('load', setCap); }
    setCap();
    [150,450,1000].forEach(function(t){ setTimeout(setCap,t); });
    var tm; window.addEventListener('resize', function(){ clearTimeout(tm); tm=setTimeout(setCap,150); });
    document.addEventListener('click', function(e){ if(e.target.closest && e.target.closest('.thumbnail-list__item')){ setTimeout(setCap,120); } }, true);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
